import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App/App';
import { Provider } from 'mobx-react';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import { Route, BrowserRouter } from 'react-router-dom';
import * as stores from './stores';

import 'normalize.css';


//debugs for state
window._____APP_STATE_____ = stores;

ReactDOM.render(
  <Provider { ...stores }>
    <BrowserRouter basename="/go/dgr" >
        <Route component={App} />
    </BrowserRouter>
  </Provider>,
  document.getElementById('content')
);

unregister();



// WEBPACK FOOTER //
// ./src/index.js